import React, { useEffect, useState } from "react";
import "../styles/pageStyles.css";
import { useDispatch, useSelector } from "react-redux";
import {
  fillCriminalDbForm,
  editCellInDataBaseDetailForm,
} from "../store/pdfdata/pdfdataSlice";
import ColorCode from "./ColorCode";
import SummaryRemarks from "./SummaryRemarks";
import ColorCheckFun from "./ColorCheckFun";
import EditCellTitleModel from "./EditCellTitleModel";
import RecursiveModal from "./RecursiveModal";
import NotificationAlert from "./NotificationAlert";

const DatabaseVerification = ({ annexure }) => {
  const modelId = "dataBaseCellTileEdit";

  const databaseForms = useSelector(
    (state) => state.pdfdata.forms["Database Verification"]
  );
  const dob = useSelector((state) => state.pdfdata["Date of Birth"]);
  const applicantName = useSelector((state) => state.pdfdata["Applicant Name"]);
  const FatherName = useSelector((state) => state.pdfdata["Father Name"]);
  const execSummary = useSelector((state) => state.pdfdata.executiveSummary);
  const [selectedCellTitle, setSelectedCellTitle] = useState("");
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const dispatch = useDispatch();

  const addVal = (e, table) => {
    e.preventDefault();
    let value = e.target.value;
    // if (e.target.name.toLowerCase().indexOf("date") !== -1) {
    //   value = moment(e.target.value, "YYYY-MM-DD").format("DD-MMM-YYYY");
    //   if (value == "Invalid date") value = "";
    // }
    dispatch(
      fillCriminalDbForm(["Database Verification", table, e.target.name, value])
    );
    if (e.target.name === "Color Code")
      ColorCheckFun(dispatch, execSummary, table, e.target.value);
  };
  useEffect(() => {
    Object.keys(databaseForms).forEach((table) => {
      if (databaseForms[table]["Name of the Applicant"] === "") {
        document.getElementById(`DatabaseVerification${table}Applicant`).value =
          applicantName.value;
      }
      if (databaseForms[table]["Father Name"] === "" && FatherName) {
        document.getElementById(`DatabaseVerification${table}Father`).value =
          FatherName.value;
      }
    });
  }, [applicantName, FatherName, databaseForms]);
  const [selectedCellPosition, setSelectedCellPosition] = useState();
  const [selectedSubForm, setSelectedSubForm] = useState("");
  //  const [selectedFormNumber, setselectedFormNumber] = useState("");
  const onEditCell = (cellTitileRef) => {
    if (cellTitileRef === "") {
      setNotify({
        isOpen: true,
        message: "Please Enter New Cell Title...",
        type: "warning",
      });
      return;
    }
    if (
      selectedSubForm === "" ||
      //  selectedFormNumber === "" ||
      selectedCellPosition === ""
    ) {
      setNotify({
        isOpen: true,
        message: "Something went wrong!!",
        type: "warning",
      });
    }
    const mainTable = "Database Verification";
    dispatch(
      editCellInDataBaseDetailForm({
        type: cellTitileRef,
        selectedSubForm,
        //  selectedFormNumber,
        selectedCellPosition,
        mainTable,
      })
    );
    setSelectedCellPosition("");
    setSelectedSubForm("");
    //  setselectedFormNumber("");
  };
  return (
    <div>
      <NotificationAlert notify={notify} setNotify={setNotify} />

      <h3 className="text-center mt-4">
        <u>Database Verification</u>
      </h3>
      <>
        {Object.keys(databaseForms).map((type, index) => (
          <table key={type}>
            <tr>
              <th className="heading" colSpan={2}>
                <h3>{type}</h3>
              </th>
            </tr>
            {Object.keys(databaseForms[type]).map((row, index) => (
              <tr>
                {row === "Name of the Applicant" ||
                row === "Color Code" ||
                row === "Date of Birth" ? (
                  <td>{row}</td>
                ) : (
                  <td className="cellTitle col-sm-6">
                    <div className="row row-cols-2">
                      <div className="col-sm-11">{row}</div>
                      <div className="col-sm-1">
                        <button
                          className="editIcon fa fa-pencil"
                          type="button"
                          data-bs-toggle="modal"
                          title="Edit Cell Title"
                          data-bs-target={`#${modelId}`}
                          data-bs-whatever="@mdo"
                          onClick={() => {
                            setSelectedCellPosition(index);
                            setSelectedSubForm(type);
                            setSelectedCellTitle(row);
                            // setselectedFormNumber("form1");
                          }}
                        ></button>
                      </div>
                    </div>
                  </td>
                )}
                {row === "Name of the Applicant" ? (
                  <td>
                    <textarea
                      style={{ width: "100%", height: 30 }}
                      id={`DatabaseVerification${type}Applicant`}
                      defaultValue={
                        databaseForms[type][row] !== ""
                          ? databaseForms[type][row]
                          : applicantName
                      }
                      name={row}
                      onChange={(e) => addVal(e, type)}
                    ></textarea>
                  </td>
                ) : row === "Father Name" && FatherName ? (
                  <td>
                    <textarea
                      style={{ width: "100%", height: 30 }}
                      id={`DatabaseVerification${type}Father`}
                      defaultValue={
                        databaseForms[type][row] !== ""
                          ? databaseForms[type][row]
                          : FatherName
                      }
                      name={row}
                      onChange={(e) => addVal(e, type)}
                    ></textarea>
                  </td>
                ) : row === "Color Code" ? (
                  <ColorCode
                    cls={databaseForms[type][row]}
                    namefield={row}
                    fun={(e) => addVal(e, type)}
                    spanNum={1}
                  />
                ) : row === "Date of Birth" && dob ? (
                  <td>{dob.value}</td>
                ) : (
                  <td>
                    {row === "Name of the Applicant" ? (
                      <> {applicantName}</>
                    ) : (
                      <textarea
                        style={{ width: "100%", height: 30 }}
                        defaultValue={databaseForms[type][row]}
                        name={row}
                        onBlur={(e) => addVal(e, type)}
                      ></textarea>
                    )}
                  </td>
                )}
              </tr>
            ))}
            <tr>
              <td>Upload Document</td>
              <td colSpan={1}>
                <RecursiveModal
                  mainTable="Database Verification"
                  subTable={type}
                  annexure={annexure + (index + 1)}
                />
                <span className="alert">
                  Files of format .jpg, .jpeg, .png, .eml are accepted!
                </span>
              </td>
            </tr>
            <SummaryRemarks
              type="Database Verification"
              namefield={type}
              spanNum={1}
            />
            <tr>
              <td colSpan={3}>
                Please Refer{" "}
                <b>
                  Annexure-{annexure}
                  {index + 1}
                </b>
              </td>
            </tr>
            <EditCellTitleModel
              modelId={modelId}
              onEditCell={onEditCell}
              currentTitle={selectedCellTitle}
              setCurrentTitle={setSelectedCellTitle}
            />
          </table>
        ))}
      </>
    </div>
  );
};
export default DatabaseVerification;
